// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bVBS_4 {
  margin: 0;
  height: 100vh;
  padding: 0 !important;
  position: fixed !important;
  right: 0;
  top: 0;
}

.uA8ttc {
  margin: 0 auto;
  max-width: var(--grid-breakpoint-l);
  height: 100vh;
  transform: none !important;
}

.u1fb6m {
  margin: 0;
  margin-left: auto;
  max-width: 400px;
  height: 100vh;
  border-radius: 0;
  border: none;
  background-color: var(--surface-neutral-white);
  display: flex;
  flex-direction: column;
}

.smbQAS {
  padding: var(--spacing-3) var(--spacing-3) 0;
  border: none;
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  flex-shrink: 0;
}

._HM_60 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xl);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.ByfcdC {
  background: none;
  border: none;
  padding: var(--spacing-0-5);
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: calc(-1 * var(--spacing-0-5));
}

.ByfcdC img {
  width: 16px;
  height: 16px;
}

.EHwJjz {
  padding: var(--spacing-3);
  overflow-y: auto;
  min-height: 0;
  flex: 1;
}

.sG3YBa {
  margin-bottom: var(--spacing-3);
}

.KwKo0r {
  margin: 0;
  margin-bottom: var(--spacing-2);
  min-width: 0;
}

.zRO55e {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: var(--spacing-1);
  text-align: center;
}

.QLNrt0 {
  background: rgba(214, 64, 0, 0.1);
  border-radius: 50%;
  display: flex;
  height: 72px;
  width: 72px;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--spacing-3);
}

.NDy0Er {
  width: 72px;
  height: 72px;
  color: var(--icon-error-medium);
  margin-bottom: var(--spacing-3);
}

.E7YFm_ {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin-bottom: var(--spacing-1);
  margin-top: 0;
}

.FqhPsn {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-stronger);
  margin-bottom: 0;
}

.Uj6WDT {
  margin-top: var(--spacing-3);
}

.tAZm4C {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-4);
  text-align: center;
}

.sN2I8O {
  width: 72px;
  height: 72px;
  color: var(--icon-neutral-stronger);
  margin-bottom: var(--spacing-3);
}

.tiA8B7 {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin-bottom: var(--spacing-1);
  margin-top: 0;
}

.X9p3hq {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-stronger);
  margin-bottom: var(--spacing-3);
  max-width: 300px;
}

.HA_mbh {
  margin-top: var(--spacing-1);
}

@media (max-width: 480px) {
  .uA8ttc {
    max-width: 100vw;
  }
}

.nOBl0_ {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  color: var(--text-neutral-dark);
  margin: 0 0 var(--spacing-2) 0;
}

.uzG3XC {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  margin-bottom: var(--spacing-3);
}

.kCQ3uk {
  background: #fff;
  padding: 14px 16px;
  box-sizing: border-box;
  border: 1px solid var(--text-neutral-soft);
  border-radius: var(--radius-s);
}

.YsYjfe {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}

.TGejwg {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--type-title-md-font-size);
  color: var(--text-neutral-dark);
}

.ZHkjgc {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
}

.FIdWXd {
  cursor: pointer;
}

.dJhsdM {
  background: none;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  color: var(--color-primary, #ff6600);
  gap: var(--spacing-0-5);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
}

.dJhsdM:hover,
.ZHkjgc:hover {
  opacity: 0.8;
}

.sPIDP2 {
  width: 16px;
  height: 16px;
}

.aYIh5h {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5);
  font-size: var(--font-size-md);
  padding-bottom: var(--spacing-1);
}

.ION8CG {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.q1HEiE {
  color: var(--text-neutral-dark);
}
.uUAJBb {
  color: var(--text-neutral-dark);
  font-weight: var(--font-weight-semibold);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/TrackingCardsModal/TrackingCardsModal.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,OAAO;AACT;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oCAAoC;EACpC,wCAAwC;EACxC,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,uBAAuB;EACvB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C","sourcesContent":[".modal {\n  margin: 0;\n  height: 100vh;\n  padding: 0 !important;\n  position: fixed !important;\n  right: 0;\n  top: 0;\n}\n\n.modalDialog {\n  margin: 0 auto;\n  max-width: var(--grid-breakpoint-l);\n  height: 100vh;\n  transform: none !important;\n}\n\n.modalContent {\n  margin: 0;\n  margin-left: auto;\n  max-width: 400px;\n  height: 100vh;\n  border-radius: 0;\n  border: none;\n  background-color: var(--surface-neutral-white);\n  display: flex;\n  flex-direction: column;\n}\n\n.modalHeader {\n  padding: var(--spacing-3) var(--spacing-3) 0;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  flex-shrink: 0;\n}\n\n.modalTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-xl);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.backButton {\n  background: none;\n  border: none;\n  padding: var(--spacing-0-5);\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin: calc(-1 * var(--spacing-0-5));\n}\n\n.backButton img {\n  width: 16px;\n  height: 16px;\n}\n\n.modalBody {\n  padding: var(--spacing-3);\n  overflow-y: auto;\n  min-height: 0;\n  flex: 1;\n}\n\n.headerSection {\n  margin-bottom: var(--spacing-3);\n}\n\n.copyAlert {\n  margin: 0;\n  margin-bottom: var(--spacing-2);\n  min-width: 0;\n}\n\n.feedbackContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: var(--spacing-1);\n  text-align: center;\n}\n\n.loadingIconContent {\n  background: rgba(214, 64, 0, 0.1);\n  border-radius: 50%;\n  display: flex;\n  height: 72px;\n  width: 72px;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: var(--spacing-3);\n}\n\n.errorIcon {\n  width: 72px;\n  height: 72px;\n  color: var(--icon-error-medium);\n  margin-bottom: var(--spacing-3);\n}\n\n.feedbackTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin-bottom: var(--spacing-1);\n  margin-top: 0;\n}\n\n.feedbackText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-stronger);\n  margin-bottom: 0;\n}\n\n.feedbackButton {\n  margin-top: var(--spacing-3);\n}\n\n.emptyState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-4);\n  text-align: center;\n}\n\n.emptyStateIcon {\n  width: 72px;\n  height: 72px;\n  color: var(--icon-neutral-stronger);\n  margin-bottom: var(--spacing-3);\n}\n\n.emptyStateTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin-bottom: var(--spacing-1);\n  margin-top: 0;\n}\n\n.emptyStateText {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-stronger);\n  margin-bottom: var(--spacing-3);\n  max-width: 300px;\n}\n\n.emptyStateButton {\n  margin-top: var(--spacing-1);\n}\n\n@media (max-width: 480px) {\n  .modalDialog {\n    max-width: 100vw;\n  }\n}\n\n.monthTitle {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  color: var(--text-neutral-dark);\n  margin: 0 0 var(--spacing-2) 0;\n}\n\n.trackingCardsList {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n  margin-bottom: var(--spacing-3);\n}\n\n.trackingCardItem {\n  background: #fff;\n  padding: 14px 16px;\n  box-sizing: border-box;\n  border: 1px solid var(--text-neutral-soft);\n  border-radius: var(--radius-s);\n}\n\n.trackingCardHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 18px;\n}\n\n.trackingCardTitle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--type-title-md-font-size);\n  color: var(--text-neutral-dark);\n}\n\n.trackingCardCopyButton {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  padding: 0;\n}\n\n.trackingCardCopyCode {\n  cursor: pointer;\n}\n\n.trackingCardDetailsLink {\n  background: none;\n  border: none;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  color: var(--color-primary, #ff6600);\n  gap: var(--spacing-0-5);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n}\n\n.trackingCardDetailsLink:hover,\n.trackingCardCopyButton:hover {\n  opacity: 0.8;\n}\n\n.trackingCardDetailsLinkIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.trackingCardBody {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5);\n  font-size: var(--font-size-md);\n  padding-bottom: var(--spacing-1);\n}\n\n.trackingCardBodyRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.trackingCardBodyLabel {\n  color: var(--text-neutral-dark);\n}\n.trackingCardBodyValue {\n  color: var(--text-neutral-dark);\n  font-weight: var(--font-weight-semibold);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `bVBS_4`,
	"modalDialog": `uA8ttc`,
	"modalContent": `u1fb6m`,
	"modalHeader": `smbQAS`,
	"modalTitle": `_HM_60`,
	"backButton": `ByfcdC`,
	"modalBody": `EHwJjz`,
	"headerSection": `sG3YBa`,
	"copyAlert": `KwKo0r`,
	"feedbackContainer": `zRO55e`,
	"loadingIconContent": `QLNrt0`,
	"errorIcon": `NDy0Er`,
	"feedbackTitle": `E7YFm_`,
	"feedbackText": `FqhPsn`,
	"feedbackButton": `Uj6WDT`,
	"emptyState": `tAZm4C`,
	"emptyStateIcon": `sN2I8O`,
	"emptyStateTitle": `tiA8B7`,
	"emptyStateText": `X9p3hq`,
	"emptyStateButton": `HA_mbh`,
	"monthTitle": `nOBl0_`,
	"trackingCardsList": `uzG3XC`,
	"trackingCardItem": `kCQ3uk`,
	"trackingCardHeader": `YsYjfe`,
	"trackingCardTitle": `TGejwg`,
	"trackingCardCopyButton": `ZHkjgc`,
	"trackingCardCopyCode": `FIdWXd`,
	"trackingCardDetailsLink": `dJhsdM`,
	"trackingCardDetailsLinkIcon": `sPIDP2`,
	"trackingCardBody": `aYIh5h`,
	"trackingCardBodyRow": `ION8CG`,
	"trackingCardBodyLabel": `q1HEiE`,
	"trackingCardBodyValue": `uUAJBb`
};
module.exports = ___CSS_LOADER_EXPORT___;
